import Vue from 'vue';
import permission from './permission'

const InitDirective = () => {
    Vue.directive('permission', permission)
}

export default InitDirective;